import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { HeroUIProvider } from "@heroui/react";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import { MobileSidebarProvider } from "./hooks/mobileSidebarContext";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { store } from "./store";
import { HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from "./components/ErrorBoundary";
import { TourProvider } from "./context/TourContext.js";
import { ToastProvider } from "@heroui/react";
import { captureAdId } from "./utils/captureMetaParams";

if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
  console.error = () => { };
  console.warn = () => { };
}

captureAdId(); 

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>

    <HelmetProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistStore(store)}>
          <HeroUIProvider>
            <NextThemesProvider attribute="class" defaultTheme="light">
              <MobileSidebarProvider>
                <ErrorBoundary>
                  <TourProvider>
                      <ToastProvider toastOffset={80}/>
                      <App />
                  </TourProvider>
                </ErrorBoundary>
              </MobileSidebarProvider>
            </NextThemesProvider>
          </HeroUIProvider>
        </PersistGate>
      </Provider>
    </HelmetProvider>

  </React.StrictMode>
);
